import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';
import logomain from '../../images/applogo.svg';
import Avatar from '../../images/avatar.svg';
import BurgerIcon from '../../images/burger.svg';
import CloseIcon from '../../images/close.svg';

function Header() {
  const [showPopup, setShowPopup] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleLogoutClick = () => {
    logout();
    setShowPopup(false);
    navigate('/');
  };

  const handleProfileClick = () => {
    navigate('/dashboard');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="HeaderApp">
      <div className="headerContent">
        <div className="logoColumn">
          <Link to="/main">    {/* ← ссылка на главную */}
            <img src={logomain} alt="Логотип" />
          </Link>
        </div>
        <div className="burgerColumn">
          <img
            src={isMenuOpen ? CloseIcon : BurgerIcon}
            alt={isMenuOpen ? "Закрыть" : "Меню"}
            onClick={toggleMenu}
            className="burgerIcon"
          />
        </div>

        <nav className={`menuColumn ${isMenuOpen ? 'menuColumn--open' : ''}`}>
          <ul className="menuList">
            <li className="menuItem"><a href="/main">Кредиты</a></li>
            <li className="menuItem"><a href="#insurance">Страхование</a></li>
            <li className="menuItem"><a href="#new">Новости</a></li>
            <li className="menuItem"><a href="#journal">Статьи</a></li>
            <li className="menuItem"><a href="#journal">Партнеры</a></li>
            <li className="menuItem"><a href="#cards">О проекте</a></li>
          </ul>
        </nav>
        <div className="AvatarColumn">
          {user ? (
            <>
              <img
                src={Avatar}
                alt="Avatar"
                onClick={() => setShowPopup(!showPopup)}
              />
              {showPopup && (
                <div className="popup">
                  <button onClick={handleProfileClick}>Профиль</button>
                  <button onClick={handleLogoutClick}>Выйти</button>
                </div>
              )}
            </>
          ) : (
            <button onClick={handleLoginClick}>Войти</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;